define('views/invite/invitelanding',["backbone",
        "text!views/invite/invitelanding.html",
        "views/_base/baseview",
        "views/invite/invite",
        "views/invite/featuredcause",
        "models/causes/cause_collection"
], function (Backbone, Template, BaseView, InviteView, FeaturedCauseView, CauseCollection) {
    //"use strict";

    return BaseView.extend({
        template: _.template(Template),
        isRender: true,
        needsAuth: true,
        activityIndicator: false,
        tagName: "section",
        id: "rewards",
        events: {
            "click #referURL": "highlightURL",
            "click .ssk": "shareClick"
        },
        initialize: function (options) {
            options = options || {};
            this.elementName = options.elementName;
            BaseView.prototype.initialize(this);            
        },
        render: function () {
            this.$el.html(this.template({ ReferralURL: pf.session.ReferralURL }));
            this.inviteView = new InviteView({ elementName: "#inviteByEmail" });

            return this;
        },
        loadData: function () {
            var that = this;

            this.incentivesOn = getApplicationControl(enums.PFControls.IncentiveProgramOn);
            // this.featuredCausesOn = getApplicationControl(enums.PFControls.FeaturedCausesOn);

            if (isEmpty(pf.session.ReferralURL)) {
                $.ajax({
                    type: 'GET',
                    url: pf.userURL + "/UserInfo",
                    data: null,
                    contentType: "application/json",
                    success: function (model, resp) {
                        pf.session.ReferralCode = model.RC;
                        pf.session.ReferralURL = model.RU;
                        pf.session.ShortReferralURL = model.SRU;
                        that.$("#referURL").val(pf.session.ReferralURL);
                    },
                    error: function (model, resp) { }
                });
            }

            // this.featuredCauses = new CauseCollection({ instanceURL: pf.accountsURL + "/Featured" });
            // if (this.featuredCausesOn == 1 && this.incentivesOn == 1) {
            //     this.featuredCauses.fetch({
            //         success: function (resp, model) {
            //             if (that.featuredCauses.length > 0) {
            //                 that.addAll();
            //                 that.$('#featuredCauses').removeClass('hidden');
            //                 that.$('ul #rewardsStep3').removeClass('hidden');
            //             }
            //             else {
            //                 that.$('#featuredCauses').remove();
            //                 that.$('#rewardsStep3').remove();
            //             }

            //         },
            //         error: function () {
            //             that.$('#featuredCauses').remove();
            //             that.$('#rewardsStep3').remove();
            //         }
            //     });
            // }
        },        
        // addAll:function(){
        //     this.featuredCauses.forEach(this.addOne, this);
        // },
        // addOne:function(model){
        //     var featuredcauseview = new FeaturedCauseView({ model: model });
        //     this.$("#featuredCauses").append(featuredcauseview.el);
        // },
        highlightURL:function(){
            this.$("#referURL").select();
        },
        winOpen: function (url) {
            var width = 575, height = 400,
                left = (document.documentElement.clientWidth / 2 - width / 2),
                top = (document.documentElement.clientHeight - height) / 2,
                opts = 'status=1,resizable=yes' + ',width=' + width + ',height=' + height + ',top=' + top + ',left=' + left;
            win = window.open(url, '', opts);
            if (win)
                win.focus();
            return win;
        },
        shareClick: function (e) {
            e.preventDefault();

            this.supportsShare = /(twitter|facebook|google-plus|pinterest|tumblr|vk|linkedin|email)/;
            this.shareOptions = {
                url: pf.session.ReferralURL,
                text: 'Join me on PayForward! Get up to 15% back when you shop & pay it forward to yourself, your friends, & your community.',
                image: 'http://cdn.payforward.com/img/payforward.png',
                twitter: {
                    text: 'Join me on PayForward! Get up to 15% back when you shop & pay it forward to yourself, your friends, & your community',
                    url: pf.session.ShortReferralURL,
                    title: ''
                }
            };
            var target = e.target;
            var match = target.className.match(this.supportsShare);
            if (!match) return;

            url = this.getUrl(match[0], target);
            if (!url) return;

            if (match[0] != 'email') {
                this.winOpen(url);
            } else {
                document.location = url;
            }
        },
        getShareUrl: function (network, el, dataOpts) {
            dataOpts = dataOpts || this.getDataOpts(network, el);
            return dataOpts['url'] || window.location.href;
        },
        getDataOpts: function (network, el) {
            var validOpts = ['url', 'title', 'text', 'image'],
            opts = {}, optValue, optKey, dataKey, a, parent = el.parentNode;
            network == 'twitter' && validOpts.push('via');
            for (a in validOpts) {
                optKey = validOpts[a];
                dataKey = 'data-' + optKey;
                optValue = el.getAttribute(dataKey) || parent.getAttribute(dataKey) || (this.shareOptions[network] && typeof this.shareOptions[network][optKey] != 'undefined' ? this.shareOptions[network][optKey] : this.shareOptions[optKey]);
                if (typeof optValue != 'undefined') {
                    opts[optKey] = optValue;
                }
            }
            return opts;
        },
        getMetaContent: function (tagName, attr) {
            var text, tag = $('meta[' + (attr ? attr : tagName.indexOf('og:') === 0 ? 'property' : 'name') + '="' + tagName + '"]');
            if (tag.length) {
                text = tag[0].getAttribute('content') || '';
            }
            return text || ''
        },
        getUrl: function (network, el) {
            var url, dataOpts = this.getDataOpts(network, el),
            shareUrl = this.getShareUrl(network, el, dataOpts),
            shareUrlEnc = encodeURIComponent(shareUrl),
            title = typeof dataOpts['title'] !== 'undefined' ? dataOpts['title'] : document.title,
            text = typeof dataOpts['text'] !== 'undefined' ? dataOpts['text'] : this.getMetaContent('description'),
            image = dataOpts['image'], via = dataOpts['via'];
            switch (network) {
                case 'facebook':
                    url = 'https://www.facebook.com/share.php?u=' + shareUrlEnc;
                    break;
                case 'twitter':
                    url = 'https://twitter.com/share?url=' + shareUrlEnc + '&text=' + encodeURIComponent(title + (text && title ? ' - ' : '') + text);
                    via = via || this.getMetaContent('twitter:site');
                    if (via) url += '&via=' + via.replace('@', '');
                    break;
                case 'google-plus':
                    url = 'https://plus.google.com/share?url=' + shareUrlEnc;
                    break;
                case 'pinterest':
                    url = 'http://pinterest.com/pin/create/button/?url=' + shareUrlEnc + '&description=' + encodeURIComponent(text);
                    image = image || this.getMetaContent('og:image');
                    if (image) url += '&media=' + encodeURIComponent(image);
                    break;
                case 'tumblr':
                    url = 'http://www.tumblr.com/share/link?url=' + shareUrlEnc + '&name=' + encodeURIComponent(title) + '&description=' + encodeURIComponent(text);
                    break;
                case 'linkedin':
                    url = 'http://www.linkedin.com/shareArticle?mini=true&url=' + shareUrlEnc + '&title=' + encodeURIComponent(title) + '&summary=' + encodeURIComponent(text);
                    break;
                case 'vk':
                    url = 'http://vkontakte.ru/share.php?url=' + shareUrlEnc;
                    break;
                case 'email':
                    url = 'mailto:?subject=' + title + '&body=' + encodeURIComponent(text + '\n\n' + shareUrl);
                    break;
            }
            return url;
        },
        close: function () {}
    });
});

